import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* ===============================
   TOGGLE FAVOURITE
================================ */
export const toggleFavourite = createAsyncThunk(
  "favourite/toggle",
  async (productId, { rejectWithValue }) => {
    try {
      const res = await api.post(
        "/api/favourites/toggle",
        { productId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      return {
        productId,
        action: res.data.action, // "added" | "removed"
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

/* ===============================
   FETCH FAVOURITES
================================ */
export const fetchFavourites = createAsyncThunk(
  "favourite/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/favourites", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

const favouriteSlice = createSlice({
  name: "favourite",
  initialState: {
    items: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* ================= FETCH ================= */
      .addCase(fetchFavourites.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFavourites.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchFavourites.rejected, (state) => {
        state.loading = false;
      })

      /* ================= TOGGLE ================= */
      .addCase(toggleFavourite.pending, (state) => {
        state.loading = true;
      })
      .addCase(toggleFavourite.fulfilled, (state, action) => {
        const { productId, action: type } = action.payload;

        if (type === "added") {
          state.items.push({
            product: { _id: productId },
          });
        } else {
          state.items = state.items.filter(
            (fav) => String(fav.product?._id) !== String(productId)
          );
        }

        state.loading = false;
      })
      .addCase(toggleFavourite.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default favouriteSlice.reducer;
